var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',{attrs:{"title":"帮助中心"}},[_c('Row',{attrs:{"gutter":20}},[_c('Col',{attrs:{"span":6}},[_c('SideBar')],1),_c('Col',{attrs:{"span":18}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }